import React, { useEffect, useState } from "react";
import TableSkeleton from "../../../../../common/TableSkeleton";
import { Bounce, toast } from "react-toastify";
import DeleteAbandonedItem from "../../DeleteAbandonedItem";
import DashboardButton from "../DashboardButton";

// table icons
const userIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/user.png`;
const emailIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/email.png`;
const cartIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/cart.png`;
const planeIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/plane.png`;
const planeHoverIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/plane-hover.png`;

const showToast = (type, message) => {
    toast[type](message, {
        position: "top-right",
        style: {
            margin: "30px 0 0 0",
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "26px",
            color: "#fff",
        },
        autoClose: 1200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
    });
};

const AbandonedCarts = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchUpdatedCartData = () => {
        const url = `${EASYCOMMERCE.rest_base}/abandoned-carts?page=1&per_page=5`;
        setIsLoading(true);

        fetch(url,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);
                if (data.success) {
                    setData(data.data.carts);
                }
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    const sendRemainder = (hash) => {
        if (!hash) return;

        const url = `${EASYCOMMERCE.rest_base}/abandoned-carts/remind`;

        easycommerce_modal(true);

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({ hash }),
        })
            .then((res) => res.json())
            .then((data) => {
                easycommerce_modal(false);

                if (data.success && data.data.mail_sent) {
                    showToast("success", data.data.message);
                } else {
                    showToast("error", data.data.message);
                }
            })
            .catch((error) => {
                easycommerce_modal(false);
                showToast("error", "Failed to send remainder.");
            });
    };

    useEffect(() => {
        fetchUpdatedCartData();
    }, []);

    return (
        <>
            {isLoading ? (
                <TableSkeleton numberOfRows={5} SkeletonHeight={35} />
            ) : data.length === 0 ? (
                <div className=" text-sm text-ec-body px-[30px] pb-[30px]">
                    No abandoned carts found.
                </div>
            ) : (
                <>
                    <div className="px-[30px]">
                        <table class="table-auto w-full px-[30px]">
                            <thead className="w-full">
                                <tr className="bg-ec-table-bg">
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize rounded-tl-md rounded-bl-md text-ec-body">
                                        Name
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize rounded-tl-md rounded-bl-md text-ec-body">
                                        Email
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize text-ec-body">
                                        Products
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize text-ec-body">
                                        Amount
                                    </th>
                                    <th className="p-3 rounded-tr-md rounded-br-md text-sm font-inter text-left font-medium capitalize text-ec-body"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item, index) => (
                                    <>
                                        {/* {index < 10 && ( */}
                                        <tr
                                            className={`${
                                                index < 4
                                                    ? "border-b border-[#F8F8F8]"
                                                    : ""
                                            } h-[70px]`}
                                            key={item}
                                        >
                                            <td className="px-3">
                                                <span className="flex justify-start items-center gap-4 py-4 text-sm font-normal text-ec-body">
                                                    {/*<img
                                                        src={userIcon}
                                                        alt="user"
                                                        className="w-[14px] h-[18px]"
                                                    />*/}
                                                    <span className="flex flex-col items-start gap-1">
                                                        <span className="font-inter">
                                                            {item.name}
                                                        </span>
                                                    </span>
                                                </span>
                                            </td>
                                            <td className="px-3">
                                                <span className="flex justify-start items-center gap-4 py-4 text-sm font-normal text-ec-body">
                                                    {/*<img
                                                        src={emailIcon}
                                                        alt="email"
                                                        className="w-[16px] h-[16px]"
                                                    />*/}
                                                    <span className="flex flex-col items-start gap-1">
                                                        <span className="font-inter">
                                                            {item.email}
                                                        </span>
                                                    </span>
                                                </span>
                                            </td>
                                            <td className="px-3">
                                                <span className="flex justify-start items-center gap-4 py-4 text-sm font-normal text-ec-body">
                                                    <span className="flex flex-col items-start gap-1">
                                                        <span className="font-inter">
                                                            {item.items}
                                                        </span>
                                                    </span>
                                                </span>
                                            </td>
                                            <td className="px-3">
                                                <span className="flex justify-start items-center gap-4 py-4 text-sm font-normal text-ec-body">
                                                    {/*<img
                                                        src={cartIcon}
                                                        alt="cart"
                                                        className="w-[18px] h-[16px]"
                                                    />*/}
                                                    <span className="flex flex-col items-start gap-1">
                                                        <span className="font-inter">
                                                            {item.total}
                                                        </span>
                                                    </span>
                                                </span>
                                            </td>
                                            <td className="px-3">
                                                <button
                                                    onClick={() => sendRemainder(item.hash)}
                                                    className="relative w-auto group text-sm font-inter text-ec-primary font-medium border border-ec-primary py-1 
                                                                px-3 rounded-lg hover:bg-ec-primary hover:text-white active:bg-ec-primary
                                                                active:text-white active:shadow-none focus:bg-ec-primary focus:text-white focus:shadow-none
                                                                transition duration-200 ease-in-out flex items-center gap-2"
                                                    >
                                                    Remind
                                                    <svg 
                                                        width="13"
                                                        height="12"
                                                        viewBox="0 0 13 12"
                                                        fill="none"
                                                        className="fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M11.6719 0.140625C11.9219 0.3125 12.0234 0.5625 11.9766 0.890625L10.4766 10.6172C10.4297 10.8516 10.3047 11.0312 10.1016 11.1562C10.0078 11.2031 9.88281 11.2344 9.72656 11.25C9.63281 11.25 9.53906 11.2344 9.44531 11.2031L6.60938 10.0078L4.61719 11.9531C4.57031 11.9844 4.52344 12 4.47656 12C4.42969 12 4.38281 11.9531 4.33594 11.8594L2.88281 8.4375L0.46875 7.42969C0.1875 7.28906 0.03125 7.07031 0 6.77344C0 6.49219 0.125 6.25781 0.375 6.07031L10.875 0.09375C11 0.03125 11.125 0 11.25 0C11.4062 0 11.5469 0.046875 11.6719 0.140625ZM0.75 6.75L2.90625 7.64062L9.65625 1.66406L0.75 6.75ZM4.71094 10.8281L5.92969 9.67969L5.10938 9.35156C5 9.30469 4.92969 9.21875 4.89844 9.09375C4.86719 8.98438 4.88281 8.88281 4.94531 8.78906L8.92969 3.32812L3.53906 8.08594L4.71094 10.8281ZM9.77344 10.3828L11.1328 1.54688L5.83594 8.83594L9.77344 10.3828Z"/>
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                        {/* )} */}
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="px-8 pb-8">
                        <DashboardButton url={`admin.php?page=easycommerce#/abandoned-cart`} />
                    </div>
                  
               
                </>
            )}
        </>
    );
};

export default AbandonedCarts;
